import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoVideo from 'eco-design/base/eco-video';
import { useRef, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import AnimatedSection from '../AnimatedSection';
import CommonTitle from '../CommonTitle';
import Tabs from '../Tabs';
import styles from './index.module.scss';

interface ChargeUpProps {
    pageType: 'max' | 'ultra';
}

const ChargeUp: React.FC<ChargeUpProps> = ({ pageType }: ChargeUpProps = { pageType: 'max' }) => {
    const { locale } = getLocal();
    const { t } = useLang('ChargeUp');
    const swiperRef = useRef<any>(null);

    const isEU = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);
    const [activeIndex, setActiveIndex] = useState(0);

    const videoArray = {
        max: {
            eu: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761205709490/%E9%A3%8E%E6%9A%B4%E6%A8%A1%E5%BC%8F_PC_EN_1_H.264.mp4',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761205627637/%E9%A3%8E%E6%9A%B4%E6%A8%A1%E5%BC%8F_M_EN_1_H.264.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1761122900026-8vegm5-compressed-Wall%20Chargin-eu.jpg',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761122990071-prdbhi-compressed-Wall%20Charging-mob-eu.jpg',
            },
            de: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761205709333/%E9%A3%8E%E6%9A%B4%E6%A8%A1%E5%BC%8F_PC_DE_1_H.264.mp4',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761205627378/%E9%A3%8E%E6%9A%B4%E6%A8%A1%E5%BC%8F_M_DE_1_H.264.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1761122788918-htl1w7-compressed-Wall%20Charging-de.jpg',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761122922628-fpbmgp-compressed-Wall%20Charging-mob-de.jpg',
            },
            fr: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761205709762/%E9%A3%8E%E6%9A%B4%E6%A8%A1%E5%BC%8F_PC_FR_1_H.264.mp4',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761205623323/%E9%A3%8E%E6%9A%B4%E6%A8%A1%E5%BC%8F_M_FR_1_H.264.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1761122850937-ct4in7-compressed-Wall%20Charging-fr.jpg',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761122940007-by5dz3-compressed-Wall%20Charging-mob-fr.jpg',
            },
            it: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761205710214/%E9%A3%8E%E6%9A%B4%E6%A8%A1%E5%BC%8F_PC_IT_1_H.264.mp4',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761205623304/%E9%A3%8E%E6%9A%B4%E6%A8%A1%E5%BC%8F_M_IT_1_H.264.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1761122869675-8xiawj-compressed-Wall%20Charging-it.jpg',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761122958302-2b88gb-compressed-Wall%20Charging-mob-it.jpg',
            },
            es: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761718180625/%E9%A3%8E%E6%9A%B4%E6%A8%A1%E5%BC%8F_PC_ES_1_H.264.mp4',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761718189090/%E9%A3%8E%E6%9A%B4%E6%A8%A1%E5%BC%8F_M_ES_1_H.264.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1761717997604-y04bzm-compressed-Wall%20Charging-es.jpg',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761718229632-8am66a-compressed-Wall%20Charging-mob-es.jpg',
            },
            uk: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1765435911268/PC.mp4',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1765435911426/M.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/upload/image/1765778137605/Wall%20Chargin-eu.jpg',
                h5Poster: 'https://websiteoss.ecoflow.com/upload/image/1765778137985/Wall%20Charging-mob-eu.jpg',
            },
        },
    };

    const imgArray = {
        max: {
            us: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/video/1759041782005/pc-2.mp4',
                    h5: 'https://websiteoss.ecoflow.com/upload/video/1759041781545/m-2.mp4',

                    pcPoster: 'https://websiteoss.ecoflow.com/upload/image/1760409899039/PC%E6%AF%94%E4%BE%8B-2%E5%BA%A6%20(0-00-02-18)%20(1).jpg',
                    h5Poster: 'https://websiteoss.ecoflow.com/upload/image/1760410335193/M%E6%AF%94%E4%BE%8B-2%E5%BA%A6%20(0-00-02-19)%20(1).jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758270966069-h4wk3b-compressed-Generator%20Charging.jpg',
                    h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758271020945-dcm1qq-compressed-Generator%20Charging.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758028060079-3kpxxj-compressed-Solar%20Charging.jpg',
                    h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758028168470-82tcr0-compressed-Solar%20Charging.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758028071212-x6h1je-compressed-Alternator%20Charging.jpg',
                    h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758028180039-b39vcp-compressed-Alternator%20Charging.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758028082332-qlsz4e-compressed-Frame%202094654352.jpg',
                    h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758028191804-psn5og-compressed-Frame%201612708119.jpg',
                },
            ],
            eu: [
                { ...(videoArray['max'][locale] || videoArray['max'].eu) },
                {
                    pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761121478669-adpqsp-compressed-Frame%201612708121.jpg',
                    h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761121559375-pt1lxi-compressed-Frame%202094654450.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761121491461-906i3d-compressed-Frame%201612708125.jpg',
                    h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761121570856-n8hgxb-compressed-Frame%202094654451.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761121506931-zrt099-compressed-Frame%202094654484.jpg',
                    h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761121583750-d526nd-compressed-Generator%20Charging.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761121526018-tndpyx-compressed-Frame%202094654445.jpg',
                    h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761121596866-ajc4kf-compressed-Frame%202094654452.jpg',
                },
            ],
            uk: [
                { ...(videoArray['max'][locale] || videoArray['max'].uk) },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1765335353522/7-pc-2.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1765335352741/7-h5-2.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1765335353292/7-pc-3.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1765335352506/7-h5-3.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1765335354476/7-pc-4.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1765335352272/7-h5-4.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1765335354270/7-pc-5.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1765335354175/7-h5-5.jpg',
                },
            ],
        },
    };

    const getImg = (key: 'max' | 'ultra', index: number) => {
        if (locale === 'uk' && key === 'max') {
            return imgArray[key]['uk'][index]
        }
        return isEU ? imgArray[key]['eu'][index] : imgArray[key]?.[locale]?.[index] || imgArray[key].us[index];
    };

    const tabs = [
        {
            tabLabel: t.rich('tab1', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            tabValue: 'tab1',
            desc: t.rich('tab1_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1757411621507-raj8sy-compressed-image%20(4)%201.jpg',
            isVideo: true,
            max: getImg('max', 0),
            ultra: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1759041781740/pc-3.mp4',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1759041781419/m-3.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/upload/image/1758004614838/PC%E6%AF%94%E4%BE%8B%20-3%E5%BA%A6%20(0-00-02-18).png',
                h5Poster: 'https://websiteoss.ecoflow.com/upload/image/1758004616171/M%E6%AF%94%E4%BE%8B-3%E5%BA%A6%20(0-00-02-16).png',
            },
        },
        {
            tabLabel: t.rich('tab2', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            tabValue: 'tab2',
            desc: t.rich('tab2_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            max: getImg('max', 1),
            ultra: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758538825217-j3qlqg-compressed-Generator%20Charging.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758539052244-ik37r2-compressed-Generator%20Charging.jpg',
            },
        },
        {
            tabLabel: t.rich('tab3', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            tabValue: 'tab3',
            desc: t.rich('tab3_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            max: getImg('max', 2),
            ultra: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758538838206-w5ocns-compressed-Solar%20Charging.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758539064900-lyqc3w-compressed-Solar%20Charging.jpg',
            },
        },
        {
            tabLabel: t.rich('tab4', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            tabValue: 'tab4',
            desc: t.rich('tab4_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            max: getImg('max', 3),
            ultra: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758538853267-1skw87-compressed-Alternator%20Charging.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758539076827-wukd9f-compressed-Alternator%20Charging.jpg',
            },
        },
        {
            tabLabel: t.rich('tab5', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            tabValue: 'tab5',
            desc: t.rich('tab5_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            max: getImg('max', 4),
            ultra: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758538870431-x3ahn2-compressed-Solar%20%2B%20Generator%20Dual%20Charging.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758539088937-ia3rn3-compressed-Solar%20%2B%20Generator%20Dual%20Charging.jpg',
            },
        },
    ];
    if (pageType === 'ultra') {
        tabs.push({
            tabLabel: t('tab6'),
            tabValue: 'tab6',
            desc: t.rich('tab6_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            max: {
                pc: '',
                h5: '',
            },
            ultra: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758722355704-0oryry-compressed-Solar%20%2B%20Alternator%20Dual%20Charging.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758722421595-bvt5xd-compressed-Solar%20%2B%20Alternator%20Dual%20Charging.jpg',
            },
        });
    }

    const onChange = (item: any, index: number) => {
        setActiveIndex(index);
        swiperRef.current.slideTo(index);
    };

    const handleSlideChange = (swiper: any) => {
        const index = swiper.realIndex; //下标

        setActiveIndex(index);
    };

    const { isH5 } = useDeviceDetect();

    return (
        <div className={`${styles.ChargeUp} GtmModuleData-section`} id="ChargeUp" data-section-id="d3m-chargeup">
            <EcoSpace hPc="160px" hPad="100px" hH5="100px" />
            <CommonTitle
                title={t.rich('title', {
                    sup: (text: string) => <sup>{text}</sup>,
                })}
                desc={t.rich('desc', {
                    sup: (text: string) => <sup>{text}</sup>,
                })}
            />
            <AnimatedSection variant="fadeInUp" options={{ stagger: 0.2, delay: 200, threshold: 0.2 }}>
                <div className="swiper-chargeup d3m-layout">
                    <Swiper
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        slidesPerView={1}
                        spaceBetween={12}
                        speed={1200}
                        modules={[Navigation]}
                        navigation={{
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }}
                        initialSlide={0}
                        onSlideChange={handleSlideChange}
                    >
                        {tabs.map((item, index) => (
                            <SwiperSlide key={index} className="list-item">
                                {item.isVideo &&
                                    (isH5 ? (
                                        <div className="video-container">
                                            <EcoVideo key={1} pc={item[pageType].h5} poster={item[pageType].h5Poster} autoPlay={true} loop={true} />
                                            {/* <video key={1} playsInline muted autoPlay loop poster={item[pageType].h5Poster}>
                                                <source src={item[pageType].h5} />
                                            </video> */}
                                        </div>
                                    ) : (
                                        <div className="video-container">
                                            <EcoVideo key={2} pc={item[pageType].pc} poster={item[pageType].pcPoster} autoPlay={true} loop={true} />
                                            {/* <video key={2} playsInline muted autoPlay loop poster={item[pageType].pcPoster}>
                                                <source src={item[pageType].pc} />
                                            </video> */}
                                        </div>
                                        // <EcoVideo key={1} pc={item[pageType].h5} poster={item[pageType].h5Poster} autoPlay={true} loop={true} />
                                        // <EcoVideo key={2} pc={item[pageType].pc} poster={item[pageType].pcPoster} autoPlay={true} loop={true} />
                                    ))}
                                {!item.isVideo && <EcoImg pc={item[pageType].pc} pad={item[pageType].pc} h5={item[pageType].h5} isOpenLazy={true} />}
                            </SwiperSlide>
                        ))}
                        <div className="swiper-button-prev" />
                        <div className="swiper-button-next" />
                    </Swiper>
                </div>
            </AnimatedSection>
            <div className="d3m-tabs">
                <Tabs className="tabs-chargeup" gtmTitle={t('title')} tabs={tabs} activeIndex={activeIndex} onChange={onChange} />
            </div>
            <div className="footer-desc d3m-layout">{tabs[activeIndex].desc}</div>
            <EcoSpace hPc="160px" />
        </div>
    );
};

export default ChargeUp;
